/**
 * Aviso de versión nueva (reescrito el 2026-10-08).
 * - En celular: un aviso abajo con «Actualizar».
 * - En escritorio: nada abajo; lo muestra la campanita (PanelNotificaciones).
 * - Sin el «Listo, ya estás en la última versión»: era un aviso de más.
 * Cualquiera puede pedir actualizar con el evento `actualizar-app`.
 */
import {
  rec_A3 as A3,
  rec_Oi as Oi,
  rec_PantallaActualizando as PantallaActualizando,
  rec_React as React,
  rec_j3 as j3,
} from "../../runtime/index.jsx";

// runtime/index.jsx importa este archivo antes de definir React (import circular).
const useEffect = (...a) => React.useEffect(...a);
const useState = (...a) => React.useState(...a);

const ESCRITORIO = `(min-width: 1024px)`;
const esEscritorio = () => {
  try {
    return window.matchMedia(ESCRITORIO).matches;
  } catch {
    return false;
  }
};

export function AvisoActualizacion() {
  const [hayNueva, setHayNueva] = useState(() => !!window.__versionNueva);
  const [actualizando, setActualizando] = useState(false);
  const [escritorio, setEscritorio] = useState(esEscritorio);

  useEffect(() => {
    const nueva = () => setHayNueva(true);
    const actualizar = () => setActualizando(true);
    window.addEventListener(`version-nueva`, nueva);
    window.addEventListener(`actualizar-app`, actualizar);
    A3();
    let mq = null;
    const cambio = () => setEscritorio(esEscritorio());
    try {
      mq = window.matchMedia(ESCRITORIO);
      mq.addEventListener(`change`, cambio);
    } catch {}
    // Marca de «estaba actualizando»: se limpia sin avisar nada.
    try {
      sessionStorage.removeItem(j3);
    } catch {}
    return () => {
      window.removeEventListener(`version-nueva`, nueva);
      window.removeEventListener(`actualizar-app`, actualizar);
      mq?.removeEventListener(`change`, cambio);
    };
  }, []);

  useEffect(() => {
    if (!actualizando) return;
    (async () => {
      try {
        sessionStorage.setItem(j3, `1`);
      } catch {}
      try {
        await (await navigator.serviceWorker?.getRegistration())?.update();
      } catch {}
      window.location.reload();
    })();
  }, [actualizando]);

  if (actualizando) return <PantallaActualizando />;
  if (!hayNueva || escritorio) return null;

  return (
    <div className="animar-entrada fixed inset-x-3 bottom-3 z-[55] mx-auto flex max-w-md items-center gap-3 rounded-2xl border border-(--border) bg-(--bg) p-3 shadow-[var(--sombra-flotante)]">
      <Oi className="h-4 w-4 shrink-0 text-(--accent)" />
      <span className="min-w-0 flex-1 text-sm text-(--text-h)">Hay una versión nueva del planner.</span>
      <button
        type="button"
        onClick={() => setActualizando(true)}
        className="shrink-0 rounded-full bg-(--accent) px-3 py-1.5 text-xs font-medium text-(--accent-fg) transition duration-150 ease-(--curva) active:scale-[0.97] hover:opacity-90"
      >
        Actualizar
      </button>
    </div>
  );
}
